import { useEffect } from "react";
import { Router, navigate } from "@reach/router";
import { PageWrap } from "../components/Layout";
//Routes
import { Shortlist } from "./search/Shortlist";
import { NotFound } from "../routes/NotFound";

import styled from "styled-components";
import { useSelector } from "react-redux";
import { hasCompaniesListingAccess } from "utils/helpers";
import { Spinner } from "@chakra-ui/react";
import { useCurrentCompany, useCurrentUser } from "hooks/auth";
import { useAuthContext } from "newui/features/Auth/context/AuthContextProvider";

export const CompaniesWrapper = styled.div`
	width: 100%;
	h1 {
		font-weight: 400;
		margin: 0px 0px 2.5rem;
		line-height: 1;
		font-size: 5.25rem;
	}
	.content-container {
		padding-top: 20px;
		padding-left: 48px;
		padding-right: 48px;
	}
	.content-container > div > div {
		padding: 0;
	}
	.content-container > div > div > div {
		display: flex;
		flex: 0 1 auto;
		flex-direction: row;
		flex-wrap: wrap;
	}
`;

export const CompanyListing = ({ company, ...props }) => {
	const currentCompany = useCurrentCompany();
	const { currentUser, isCompanyAdmin } = useCurrentUser();
	const { isAuthenticating } = useAuthContext();
	const searchLoading = useSelector((state) => state?.search?.isLoading);
	const searchHasData = useSelector(
		(state) => state?.search?.searchResult?.length > 0
	);
	const searchPaginationMeta = useSelector(
		(state) => state?.search?.paginationMeta
	);

	useEffect(() => {
		// only check access after both user and company data are loaded
		if (!isAuthenticating && currentCompany && currentUser) {
			// Allow access if user is admin OR has companies listing access
			if (!isCompanyAdmin || !hasCompaniesListingAccess(currentCompany)) {
				navigate("/403");
			}
		}
	}, [currentCompany, isAuthenticating, isCompanyAdmin, currentUser]);

	if (
		isAuthenticating ||
		!currentCompany ||
		Object.keys(currentCompany).length === 0
	) {
		return <Spinner size="xl" />;
	}

	// isDataLoading is true when loading or no data has been received yet
	const isDataLoading = searchLoading || (!searchHasData && !searchLoading);

	return (
		<PageWrap>
			<CompaniesWrapper>
				<Router primary={false}>
					<Shortlist
						path="/"
						admin={props.admin}
						linkNewTab
						className="shortlist-container"
						isDataLoading={isDataLoading}
						paginationMeta={searchPaginationMeta}
					/>
					<NotFound default />
				</Router>
			</CompaniesWrapper>
		</PageWrap>
	);
};
